import React, {Component} from "react";
import pcbColor from '../../../assets/img/pcbColor.png';
import './QuotationForm.css'

class PCBColor extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p> レジストインク（ソルダーマスク）の色指定です。なお白いソルダーマスクの場合はシルク印字が黒色、他のカラーの場合、シルク印字は白色となります。
                </p>
                <p> ご注意：注文確認後、色を変更することはできません。
                </p>
                <div className="row">
                    <img src={pcbColor} className="img-pcbClr" width="45%" height="45%"/>
                </div>
            </div>
        );
    }
}

export default PCBColor;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBColor.js